<template>
  <div>
    <div
        class="d-flex fd-column container">
      <h2 class="p-l-1:mo">
        What's New?
      </h2>
      <div class="d-flex jc-between fd-column:mo">
        <notification-tabs />
        <form novalidate @submit.prevent="search($event)" class="p-1:mo p-b-2">
          <whats-new-search-input
              v-if="activeNotificationTabName===$options.NOTIFICATION_TAB_NAMES.updates.key"
              ref="whatsNewSearch"
              @input="search($event)"
              :value="query"
              placeholderText="Search Update"
              @clear="clear"
              @click.native="focused = true">
            <label
                class="text-lg p-y-1 d-flex ai-center link"
                for="whatsNewSearch">
              clear
            </label>
          </whats-new-search-input>
        </form>
      </div>
    </div>
    <div
        v-infinite-scroll="{
          promise: notificationsMetadata.hasMore && fetchMoreNotifications
        }"
        class="NOTIFICATION-CONTAINER"

        v-if="activeNotificationTabName===$options.NOTIFICATION_TAB_NAMES.notification.key">
      <notification-list
          :meta="notificationsMetadata"
          :grouped-notifications="dateGroupedNotifications"
          @notificationClick="notificationClick"
      />
    </div>
    <div
        v-if="activeNotificationTabName===$options.NOTIFICATION_TAB_NAMES.updates.key"
        :key="listKey"
        class="NOTIFICATION-CONTAINER">
      <div>
        <div v-if="searchTerm" class="bg-gray30 p-1">
          <p class="text-bold">{{ resultsMessage }}</p>
          <p v-if="!numberOfResults" class="text-sm">
            Sorry, we didn't find anything for those search terms.
          </p>
        </div>
        <whats-new-list
            v-if="whatsNewItems"
            :open-image-modal="openImageModal"
            :grouped-whats-new="whatsNewItems"
        />
        <div class="w-100" v-else>
          <div class="h5 p-2">Check back later for the latest updates.</div>
        </div>
      </div>
    </div>
    <div>
      <image-modal
          :is-open="isOpen"
          :image="currentImage"
          @close="close"/>
    </div>
  </div>
</template>

<script>
import notifications from '@/mixins/notifications';
import { mapGetters, mapMutations } from 'vuex';
import { NOTIFICATION_TAB_NAMES } from '@/constants/notification-tab-names';
import WhatsNewSearchInput from './components/WhatsNewSearchInput';
import WhatsNewList from './components/WhatsNewList';
import NotificationList from './components/NotificationList';
import NotificationTabs from './components/NotificationTabs';
import ImageModal from './components/ImageModal';

export default {
  NOTIFICATION_TAB_NAMES,
  name: 'notifications',
  components: {
    NotificationList,
    WhatsNewList,
    NotificationTabs,
    WhatsNewSearchInput,
    ImageModal,
  },
  mixins: [
    notifications,
  ],
  data () {
    return {
      query: this.searchTerm || '',
      listKey: 0,
      isOpen: false,
      currentImage: '',
    };
  },
  computed: {
    ...mapGetters('prohub/whatsNew', [
      'groupedWhatsNewItems', 'groupedWhatsNewSearch', 'searchTerm',
    ]),
    activeNotificationTabName () {
      return this.$route.params.activeNotificationTab;
    },
    resultsMessage () {
      return this.numberOfResults ? `We found ${this.numberOfResults} results for "${this.searchTerm}"`
        : `No results found for "${this.searchTerm}"`;
    },
    whatsNewItems () {
      return this.searchTerm ? this.groupedWhatsNewSearch : this.groupedWhatsNewItems;
    },
    numberOfResults () {
      return Object.entries(this.groupedWhatsNewSearch)
        .map(entry => entry[1].length)
        .reduce((acc, next) => acc + next, 0);
    },
  },
  async mounted () {
    this.markAllNotificationsAsSeen();
  },
  methods: {
    ...mapMutations('prohub/whatsNew', ['setSearchTerm']),
    notificationClick (activityId) {
      this.markNotificationAsRead(activityId);
      const route = this.getNotificationRouteById(activityId);
      if (route) { this.$router.push(route); }
    },
    search (searchTerm) {
      this.focused = true;
      this.setSearchTerm({ searchTerm });
      if (this.searchTerm) {
        this.$events.$emit(this.$events.WHATS_NEW_SEARCH, { searchString: this.searchTerm });
      }
      this.listKey += 1;
    },
    clear () {
      this.searchTerm = '';
      this.listKey += 1;
    },
    openImageModal (url) {
      this.currentImage = url;
      this.isOpen = true;
    },
    close () {
      this.isOpen = false;
      this.currentImage = '';
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .NOTIFICATION-CONTAINER{
    flex: 1;
    overflow: auto;
    max-height: 80vh;
  }
</style>
